/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPermissionStatus {
  Disabled = 0,
  ReadOnly = 1,
  Full = 2,
}
